import request from "./request";
import store from "@/store";
import { Arg, RequestBody } from "alova";
import { getCookie } from "@/utils/auth";
export interface LoginParams {
  phone?: string;
  account_name?: string;
  email?: string;
  login_method: number;
  code: string;
  source: number;
  source_code?: string;
  activity_id?: number;
  pwa_channel_id?: string;
  visitor_id?: string;
  visitorId?: string;
  type?: string;
  promoteUrlId?: string;
  requestId?: string;
  fbclid?: string;
  promote_url_id?: string;
  rb_pixel_id?: string;
}

export interface LoginResponse {
  token: string;
  user: {
    id: number;
    phone: string;
    balance: number;
    nickname?: string;
    avatar?: string;
  };
}

export interface UserInfo {
  has_unread_notify: any;
  unread_num: number;
  user: {
    id: number;
    uuid: number;
    nickname: string;
    username: string;
    phone: string;
    email: string;
    CPF: string;
    pix: string;
    accountType: number;
    customerName: string;
    merchantUserId: string;
    avatar: string;
    gender: number;
    reg_ip: string;
    level: number;
    invite_code: string;
    source: number;
    father_id: number;
    is_recharge: number;
    is_black: number;
    is_login: number;
    remake: string;
    created_at: number;
    created_by: string;
    updated_at: number;
    updated_by: string;
  };
  user_wallet: {
    id: number;
    user_id: number;
    total_balance: number;
    wallet_id: number;
    cash_balance: number;
    digital_balance: number;
    wallet_status: string;
    total_deposit: number;
    total_withdrawal: number;
    created_at: number;
    created_by: string;
    updated_at: number;
    updated_by: string;
  };
}

export interface UserInfoResponse {
  code: number;
  data: {
    id: number;
    phone: string;
    balance: number;
    nickname?: string;
    avatar?: string;
    vipLevel?: number;
  };
  message: string;
}

export const login = (params: LoginParams) => {
  return request.Post("/login", params);
};
// 创建访客登录接口
export const guestLongin = (
  visitor_id?: string,
  source?: number,
  promoteUrlId?: string,
  requestId?: string
) => {
  return request.Post("/create/visitor", {
    visitor_id,
    source,
    promote_url_id: promoteUrlId,
    request_id: requestId,
  });
};

// 切换账号登录接口
export const switchAccountLogin = (params: {
  visitor_id: string;
  user_id: number;
}) => {
  return request.Post("/user/switch/account/login", params);
};

export const register = (params: LoginParams) => {
  if (getCookie("fbclid")) {
    params.fbclid = getCookie("fbclid");
    params.promote_url_id = getCookie("promote_url_id");
    params.rb_pixel_id = getCookie("rb_pixel_id");
  }
  return request.Post("/register", params);
};

export const loginDevice = (params: any) => {
  return request.Post("/login_device", params);
};

export const refreshToken = (params: any) => {
  return request.Post("/refresh_token", params);
};

export const sendVerificationCode = (
  type: string,
  phone: string,
  md5: string
) => {
  return request.Post("/sendsms", {
    sms_channel: type,
    mobile: phone,
    md5: md5,
  });
};

// 发送邮箱验证码
export const sendEmailCode = (email: string) => {
  return request.Post("/send_email_code", { email });
};

export interface ResetPasswordByEmailRequest {
  email: string;
  verification_code: string;
  new_password: string;
  confirm_password: string;
}
export const resetPasswordByEmail = (data: ResetPasswordByEmailRequest) => {
  return request.Post("/reset_password_by_email", data);
};

// 重置密码接口
export interface ResetPasswordParams {
  account_name: string;
  password: string;
  code: string;
}

export const resetPassword = (params: ResetPasswordParams) => {
  return request.Post("/reset_password", params);
};

/**
 * 获取用户详情信息
 */
export const getUserInfo = () => {
  return request.Post<UserInfo>("/user/info");
};

/**
 * 获取系统公告列表
 * @param params 查询参数
 * @returns 公告列表数据
 */
export function getNoticeList(params?: {
  notice_type: number;
  sort?: string;
  page: number;
  size: number;
  user_id?: number;
}) {
  return request.Get("/getNoticeList", { params });
}
// /**
//  * 获取奖励公告列表
//  * @param params 查询参数
//  * @returns 公告列表数据
//  */
// export function getJctNoticeList(params: { page: number; size: number }) {
//   return request.Get("/getSystemList", { params });
// }

export function doCheckIn(params: { user_id: number }) {
  return request.Post("/checkin/do", params);
}

// 获取用户消息列表
export function getUserNoticeList(params: {
  sort?: string;
  page: number;
  size: number;
  user_id?: number;
}) {
  return request.Get("/notice/getCenterList", {
    params: { ...params, date: new Date().getTime() },
  });
}
// 获取用户获取通知
export function getUserNotify(params: {}) {
  return request.Get("/notify_v2/get_notify", {
    params: { ...params, date: new Date().getTime() },
  });
}
export function getUserNotifyV3(params: {}) {
  return request.Get("/notify_v3/get_notify", {
    params: { ...params, date: new Date().getTime() },
  });
}
export function getUnreadCount(params: {} = {}) {
  return request.Get("/notify_v3/get_unread_count", {
    params: { ...params, date: new Date().getTime() },
  });
}
// 领取所有通知
export function collectAllNotify(params: { user_id: number }) {
  return request.Post("/notify_v3/collect_all", params);
}
// 删除所有通知
export function deleteAllNotify(params: { user_id: number }) {
  return request.Post("/notify_v3/delete", params);
}
// 领取奖励
export function collectNotify(params: { user_id: number; record_id: number }) {
  return request.Post("/download_activity/collect", params);
}
// 获取用户消息详情
export function readNotice(params: { notice_id: string; user_id?: number }) {
  return request.Post("/notice/read", params);
}
// 记录点击事件
export function addClick() {
  return request.Get("/download_activity/add_click", {
    params: { date: new Date().getTime() },
  });
}
// 记录下载事件
export function addDownload() {
  return request.Get("/download_activity/add_download", {
    params: { date: new Date().getTime() },
  });
}
// type EventRequest struct {
// 	IsNew               bool  `json:"is_new"`                // 首次登录
// 	FirstRechargeCount  int64 `json:"first_recharge_count"`  // 首充人次
// 	RechargeAmount      int64 `json:"recharge_amount"`       // 充值金额
// 	FirstRechargeAmount int64 `json:"first_recharge_amount"` // 首充金额
// }
// 记录点击事件
export function recordClick(hearPams: {
  x_channel_link_id: string;
  x_channel_event_code: string;
  x_channel_id: string;
}, params: {
  is_new?: boolean, // 首次登录
  first_recharge_count?: number, // 首充人次
  recharge_amount?: number, // 充值金额
}) {
  return request.Post("/pwa/do", params, {
    headers: {
      "x-channel-link-id": hearPams.x_channel_link_id,
      "x-channel-event-code": hearPams.x_channel_event_code,
      "x-channel-id": hearPams.x_channel_id,
    },
  });
}
// 编辑用户信息
export function updateUserProfile(params: {
  uuid: number;
  username?: string;
  email?: string;
  nickname?: string;
  CPF?: string;
  pix?: string;
  trc20?: string;
  accountType?: string;
  customerName?: string;
  merchantUserId?: string;
  avatar?: string;
  gender?: string;
  is_black?: string;
}) {
  return request.Post("/user/update", {
    ...store?.state?.auth?.user,
    ...params,
  });
}

// 编辑用户密码
export function updateUserPassword(data: RequestBody | undefined) {
  return request.Post("/user/change_password", data);
}

// 绑定用户手机号｜邮箱
export interface BindUserParams {
  type: number; // 0:手机号, 1:邮箱
  value: string; // 手机号|邮箱
  sms_code: string; // 验证码
}

export function bindUserPhoneOrEmail(params: BindUserParams) {
  return request.Post("/user/bind/phone-email", params);
}

// 检查手机号/邮箱是否存在
export function checkPhoneEmail(params: { type: number; value: string }) {
  return request.Get<{ exists: boolean }>("/user/check/phone-email", { params: { ...params, date: new Date().getTime() } });
}

// 绑定手机号
export function bindVisitorPhone(params: { phone: string; password: string }) {
  return request.Post("/user/bind/visitor/phone", params);
}

interface GenerateShortUrlParams {
  activity_id: number;
  user_id: number;
}

interface ShortUrlResponse {
  id: number;
  key: string;
  short_link: string;
  origin_link: string;
  pv: number;
  uv: number;
  create_at: string;
  create_by: number;
  update_at: string;
  update_by: number;
}

/**
 * 生成短链接
 */
export const generateShortUrl = (data: GenerateShortUrlParams) => {
  return request.Post<{ short_link?: string }>("/short_url/generate", data);
};

/**
 * 获取短链详情
 */
export const getShortLinkDetail = (shortCode: string, lotoInvite?: string) => {
  if (localStorage.getItem("lotoInvite") === "true" || lotoInvite === "true") {
    return request.Get(`/s/?agentid=${shortCode}`);
  } else {
    return request.Get(`/s/${shortCode}`);
  }
};

interface RankingItem {
  id: number;
  bettor_id: number;
  bet_date: string;
  referrers_id: number;
  level: number;
  digital_amount: number;
  status: number;
}

interface RankingReward {
  referrers_id: number;
  digital_amount: string;
}

interface RankingResponse {
  rank: RankingItem[];
  reward: RankingReward;
}

/**
 * 获取邀请排行榜数据
 */
export const getInviteRanking = (params: {
  activity_id: number;
  user_id: number;
}) => {
  return request.Post<RankingResponse>("/short_url/rank", params);
};

/**
 * 获取上周邀请排行榜数据
 */
export const getInviteWeekRrank = (params: {
  activity_id: number;
  user_id: number;
}) => {
  return request.Post<RankingResponse>("/short_url/week_rank", params);
};
/**
 * 退出登录
 */
export const logoutPost = () => {
  return request.Post<RankingResponse>("/user/logout");
};

// 邀请列表项接口
export interface InviteListItem {
  user_id: string;
  invite_level: number;
  register_time: string;
  commission: string;
}

// 扫码列表项接口
export interface ScanCodeListItem {
  user_id: string;
  invite_level: number;
  total_bet_amount: string;
  last_bet_date: string;
  commission_earned: string;
}

// 邀请列表响应接口
export interface InviteListResponse {
  total: number;
  list: InviteListItem[];
  total_commission: string;
  invite_ctx: string;
  invite_rule: string;
  invite_link: string;
}

// 扫码列表响应接口
export interface ScanCodeListResponse {
  total: number;
  list: ScanCodeListItem[];
  total_bet_commission: string;
}

// 邀请列表查询参数
export interface InviteListParams {
  page: number;
  page_size: number;
  sort_by: string;
  sort_order: string;
  query_inviter_uuid: string;
}

/**
 * 获取邀请清单
 */
export const invertList = (params?: InviteListParams) => {
  return request.Post<InviteListResponse>("/invert_list/list_details", params);
};

/**
 * 获取扫码清单
 */
export const scanCodeList = (params: InviteListParams) => {
  return request.Post<ScanCodeListResponse>(
    "/inviter/scan_code_list/details",
    params
  );
};

/**
 * 获取邀请概览查询页面
 */
export const overview = (params: RequestBody | undefined) => {
  return request.Post("/invert_list/overview", params);
};

/**
 * 获取团队数据
 */
export const teamMembers = (params: Arg | undefined) => {
  return request.Get("/invert_list/team/members", {
    params: { ...params, date: new Date() },
  });
};

/**
 * 获取团队下级数据
 */
export const subordinates = (id: number) => {
  return request.Get(`/invert_list/team/subordinates/${id}`, {});
};



/**
 * 获取EVENT cookie
 */
export const getEventCookie = () => {
  // 开发环境怎么处理？
  return request.Get(`/pwa/cookie`, {});
};

